import { render, staticRenderFns } from "./TaskDetailsTitle.vue?vue&type=template&id=55d84fee&scoped=true"
import script from "./TaskDetailsTitle.vue?vue&type=script&lang=ts"
export * from "./TaskDetailsTitle.vue?vue&type=script&lang=ts"
import style0 from "./TaskDetailsTitle.vue?vue&type=style&index=0&id=55d84fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d84fee",
  null
  
)

export default component.exports